'use client';

import { toQueryString } from '@/lib/helpers';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useAppState } from '../providers/state-provider';

export default function AuthorsTabLink({
  tab,
  linkText,
  setTab,
  paramSetup,
}: {
  tab: string;
  linkText: string;
  setTab: (tab: string) => void;
  paramSetup: (
    isSearch: boolean,
    searchParams: URLSearchParams,
  ) => URLSearchParams;
}) {
  const {
    state: { searchParams },
  } = useAppState();
  const pathname = usePathname();
  const isSearch = pathname.startsWith('/search');

  return (
    <Link
      className='flex h-10 w-full items-center justify-center'
      href={`${isSearch ? pathname : '/author-list'}${toQueryString(
        paramSetup(isSearch, new URLSearchParams(searchParams)),
      )}`}
      onClick={() => setTab(tab)}
    >
      {linkText}
    </Link>
  );
}
